import { ModuleModel } from '../../module.model.interface';
import { WorkflowTemplateModel } from '../../workflow.template/model/workflow.template.model';

export enum WorkflowInstanceState {
  Created,
  Running,
  Finished,
  Suspended,
  Failed,
  Migrating
}

export class WorkflowInstanceStateDetail {
  public id: string;
  public name: string;

  constructor(options?: {
    id: string,
    name: string,
  }) {

    if (options) {
      this.id = options.id;
      this.name = options.name;
    }
  }
}

export const WorkflowInstanceStateMap = {
  Created: new WorkflowInstanceStateDetail({ id: 'Created', name: 'Létrehozva' }),
  Running: new WorkflowInstanceStateDetail({ id: 'Running', name: 'Futó' }),
  Finished: new WorkflowInstanceStateDetail({ id: 'Finished', name: 'Befejezett' }),
  Suspended: new WorkflowInstanceStateDetail({ id: 'Suspended', name: 'Felfüggesztett' }),
  Failed: new WorkflowInstanceStateDetail({ id: 'Failed', name: 'Sikertelen' }),
  Migrating: new WorkflowInstanceStateDetail({ id: 'Migrating', name: 'Migrálás alatt' }),
};

export const WorkflowInstanceStateList: WorkflowInstanceStateDetail[] = [
  WorkflowInstanceStateMap.Created,
  WorkflowInstanceStateMap.Running,
  WorkflowInstanceStateMap.Finished,
  WorkflowInstanceStateMap.Suspended,
  WorkflowInstanceStateMap.Failed,
  WorkflowInstanceStateMap.Migrating,
];

export class WorkflowInstanceDescriptor implements ModuleModel {
  public discriminator = 'WorkflowInstanceDescriptor';

  public id: string;
  public workflowTemplateId: string;
  public relatedObjectId: string;
  public relatedObjectType: string;
  public workflowInstanceState: WorkflowInstanceState;
  public currentStepId: string;
  public context: string;
  public reference: string;

  public href: string;
  public modified: Date;
  public deleted: Date;

  public workflowTemplateDetail: WorkflowTemplateModel;
  public workflowTemplateTitle: string;

  constructor(options?: {
    id: string;
    workflowTemplateId: string;
    relatedObjectId: string;
    relatedObjectType: string;
    workflowInstanceState: WorkflowInstanceState;
    currentStepId: string;
    context: string;
    reference: string;

    href: string;
    modified: Date;
    deleted: Date;
  }) {

    if (options) {
      this.id = options.id;
      this.workflowTemplateId = options.workflowTemplateId;
      this.relatedObjectId = options.relatedObjectId;
      this.relatedObjectType = options.relatedObjectType;
      this.workflowInstanceState = options.workflowInstanceState;
      this.currentStepId = options.currentStepId;
      this.context = options.context;
      this.reference = options.reference;

      this.href = options.href;
      this.modified = options.modified;
      this.deleted = options.deleted;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/workflow.instance/model/workflow.instance.ts